/**
 * The external dependencies.
 */
import {all, call, takeLatest} from 'redux-saga/effects';
/**
 * The internal dependencies.
 */
import request from '../../common/request';
import {
    authCheckLogin,
    authCheckLoginReceived,
    authLogout,
    authReceiveLogin,
    authRequestLogin,
    getConfig,
    setConfig
} from './actions';
import {endRequestWithError} from "../requests/actions";
import store from '../../store';

/**
 * Start a network request to fetch content.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerAuthRequestLogin(action) {
    const {username, password} = action.payload;

    yield call(request, {
        endpoint: 'login',
        params: [username, password],
        requestAction: action,
        receiveAction: authReceiveLogin,
    });
}

export function* workerAuthCheckLogin(action) {

    // if (action.payload !== undefined && action.payload.error !== undefined && action.payload.error === "UserNotIn"){
    //     window.location.reload();
    //     // yield null;
    // } else {

    // console.log("EndwithErrorCatcher:", action);

    if (action.type === 'auth/checkLogin') {
        yield call(request, {
            endpoint: 'checkLogin',
            params: [],
            requestAction: action,
            receiveAction: authCheckLoginReceived,
        });
    }
    //}
}

export function* workerAuthLogout(action) {

    yield call(request, {
        endpoint: 'logout',
        params: [],
        requestAction: action,
        receiveAction: authCheckLogin,
    });
}

export function* workerGetConfig(action) {
    yield call(request, {
        endpoint: 'getConfig',
        params: [],
        requestAction: action,
        receiveAction: setConfig,
    });
}

export function* workerAuthCheckLoginReceived(action) {

    if (action.payload.status === 200) {
        const response = action.payload;
        // console.log("checklogin recived response", response.data);
        yield store.dispatch(authReceiveLogin({
            ...response.data,
            fullname: response.data.firstname + " " + response.data.lastname,
        }));

    } else if (window.location.pathname.includes('login')) {
        yield;
    } else if (action.payload.status === 400) {
        if (window.cordova) {
            window.location = "/android_asset/www/index.html";
        } else {
            yield window.location.assign(window.location.protocol + '//' + window.location.host + '/login');
        }
    } else {
        if (window.cordova) {
            window.location = "/android_asset/www/index.html";
        } else {
            yield window.location.assign(window.location.protocol + '//' + window.location.host + '/login');
        }
    }
}

/**
 * Coordinate the workers.
 *
 * @return {Generator}
 */
export default function* ContentForeman() {
    yield all([
        takeLatest(authRequestLogin, workerAuthRequestLogin),
        takeLatest(authCheckLogin, workerAuthCheckLogin),
        takeLatest(endRequestWithError, workerAuthCheckLogin),
        takeLatest(authLogout, workerAuthLogout),
        takeLatest(authCheckLoginReceived, workerAuthCheckLoginReceived),
        takeLatest(getConfig, workerGetConfig),
        takeLatest(authCheckLoginReceived, workerGetConfig)
    ]);
}



// WEBPACK FOOTER //
// ./src/store/auth/effects.js